/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PutTeamsIdMembersMemberidRoleMutationRequest,
  PutTeamsIdMembersMemberidRoleMutationResponse,
  PutTeamsIdMembersMemberidRolePathParams,
  PutTeamsIdMembersMemberidRole400,
  PutTeamsIdMembersMemberidRole401,
  PutTeamsIdMembersMemberidRole403,
  PutTeamsIdMembersMemberidRole500,
} from "../types/PutTeamsIdMembersMemberidRole.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const putTeamsIdMembersMemberidRoleMutationKey = () =>
  [{ url: "/teams/:id/members/:memberId/role" }] as const;

export type PutTeamsIdMembersMemberidRoleMutationKey = ReturnType<
  typeof putTeamsIdMembersMemberidRoleMutationKey
>;

/**
 * @description Капитан может изменить роль любого участника кроме себя.
 * Доступные роли: Top, Jungle, Mid, Adc, Support, Substitute, Coach.
 * @summary Изменение роли участника команды
 * {@link /teams/:id/members/:memberId/role}
 */
export async function putTeamsIdMembersMemberidRole(
  id: PutTeamsIdMembersMemberidRolePathParams["id"],
  memberId: PutTeamsIdMembersMemberidRolePathParams["memberId"],
  data: PutTeamsIdMembersMemberidRoleMutationRequest,
  config: Partial<
    RequestConfig<PutTeamsIdMembersMemberidRoleMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutTeamsIdMembersMemberidRoleMutationResponse,
    ResponseErrorConfig<
      | PutTeamsIdMembersMemberidRole400
      | PutTeamsIdMembersMemberidRole401
      | PutTeamsIdMembersMemberidRole403
      | PutTeamsIdMembersMemberidRole500
    >,
    PutTeamsIdMembersMemberidRoleMutationRequest
  >({
    method: "PUT",
    url: `/teams/${id}/members/${memberId}/role`,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}

export function putTeamsIdMembersMemberidRoleMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutTeamsIdMembersMemberidRoleMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putTeamsIdMembersMemberidRoleMutationKey();
  return mutationOptions<
    ResponseConfig<PutTeamsIdMembersMemberidRoleMutationResponse>,
    ResponseErrorConfig<
      | PutTeamsIdMembersMemberidRole400
      | PutTeamsIdMembersMemberidRole401
      | PutTeamsIdMembersMemberidRole403
      | PutTeamsIdMembersMemberidRole500
    >,
    {
      id: PutTeamsIdMembersMemberidRolePathParams["id"];
      memberId: PutTeamsIdMembersMemberidRolePathParams["memberId"];
      data: PutTeamsIdMembersMemberidRoleMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, memberId, data }) => {
      return putTeamsIdMembersMemberidRole(id, memberId, data, config);
    },
  });
}

/**
 * @description Капитан может изменить роль любого участника кроме себя.
 * Доступные роли: Top, Jungle, Mid, Adc, Support, Substitute, Coach.
 * @summary Изменение роли участника команды
 * {@link /teams/:id/members/:memberId/role}
 */
export function usePutTeamsIdMembersMemberidRole<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PutTeamsIdMembersMemberidRoleMutationResponse>,
      ResponseErrorConfig<
        | PutTeamsIdMembersMemberidRole400
        | PutTeamsIdMembersMemberidRole401
        | PutTeamsIdMembersMemberidRole403
        | PutTeamsIdMembersMemberidRole500
      >,
      {
        id: PutTeamsIdMembersMemberidRolePathParams["id"];
        memberId: PutTeamsIdMembersMemberidRolePathParams["memberId"];
        data: PutTeamsIdMembersMemberidRoleMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutTeamsIdMembersMemberidRoleMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putTeamsIdMembersMemberidRoleMutationKey();

  const baseOptions = putTeamsIdMembersMemberidRoleMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PutTeamsIdMembersMemberidRoleMutationResponse>,
    ResponseErrorConfig<
      | PutTeamsIdMembersMemberidRole400
      | PutTeamsIdMembersMemberidRole401
      | PutTeamsIdMembersMemberidRole403
      | PutTeamsIdMembersMemberidRole500
    >,
    {
      id: PutTeamsIdMembersMemberidRolePathParams["id"];
      memberId: PutTeamsIdMembersMemberidRolePathParams["memberId"];
      data: PutTeamsIdMembersMemberidRoleMutationRequest;
    },
    TContext
  >;

  return useMutation<
    ResponseConfig<PutTeamsIdMembersMemberidRoleMutationResponse>,
    ResponseErrorConfig<
      | PutTeamsIdMembersMemberidRole400
      | PutTeamsIdMembersMemberidRole401
      | PutTeamsIdMembersMemberidRole403
      | PutTeamsIdMembersMemberidRole500
    >,
    {
      id: PutTeamsIdMembersMemberidRolePathParams["id"];
      memberId: PutTeamsIdMembersMemberidRolePathParams["memberId"];
      data: PutTeamsIdMembersMemberidRoleMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PutTeamsIdMembersMemberidRoleMutationResponse>,
    ResponseErrorConfig<
      | PutTeamsIdMembersMemberidRole400
      | PutTeamsIdMembersMemberidRole401
      | PutTeamsIdMembersMemberidRole403
      | PutTeamsIdMembersMemberidRole500
    >,
    {
      id: PutTeamsIdMembersMemberidRolePathParams["id"];
      memberId: PutTeamsIdMembersMemberidRolePathParams["memberId"];
      data: PutTeamsIdMembersMemberidRoleMutationRequest;
    },
    TContext
  >;
}
